import CtaLink from '../../Atoms/CtaLink';
import IconsBelt from '../IconsBelt';

const ContactBlock = ({ cta, title, items, analytics, ctaAttributes }) => {
  return (
    <div className="m-contact-block">
      {title && <p className="m-contact-block__title h h6">{title}</p>}
      {items && <IconsBelt items={items} className="m-contact-block__items" />}
      {cta && (
        <CtaLink
          {...cta}
          mods={['primary', 's']}
          extra="m-contact-block__more-link"
          attributes={ctaAttributes}
          onClickAnalyticData={
            analytics
              ? {
                  event: analytics.event,
                  event_origin: 'front_end',
                  content_type: analytics.contentType,
                  vendor_name: analytics.title,
                  product_category: analytics.productCategory.label,
                  zip_code: analytics.zip,
                }
              : null
          }
        />
      )}
    </div>
  );
};

export default ContactBlock;
